import { render, staticRenderFns } from "./EmailNotificationsSettingsEditForm.vue?vue&type=template&id=2a38c450&scoped=true&"
import script from "./EmailNotificationsSettingsEditForm.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationsSettingsEditForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationsSettingsEditForm.vue?vue&type=style&index=0&id=2a38c450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38c450",
  null
  
)

export default component.exports